import { useEffect, useCallback, useRef } from 'react';
import { useCurrentAccountId } from '@adsk/alloy-provider';
import { useDataApi } from '@adsk/alloy-helpers';
import { OP_STATUSES } from '@common/constants';
import { buildCreateAccountUsersRequest } from '../utils';
import { ACTIONS } from '../state/actions';

const useCreateAccountUsers = ({ onSubmit, dispatch }) => {
  const accountId = useCurrentAccountId();
  const latestOnSubmit = useRef(onSubmit);

  // Create Account Users
  const {
    data: createAccountUsers,
    error: createAccountUsersError,
    doFetch: doCreateAccountUsersFetch,
  } = useDataApi();

  const createAccountUsersRequest = useCallback(
    ({ accessLevels, defaultCompanyId, defaultRoleId, emails }) => {
      const users = emails.map((email) => ({
        email: email.label,
        ...(defaultCompanyId && { defaultCompanyId }),
        ...(defaultRoleId && { defaultRoleId }),
        ...(accessLevels && { accessLevels }),
      }));
      const usersData = {
        users,
      };

      doCreateAccountUsersFetch(
        ...buildCreateAccountUsersRequest(accountId, usersData)
      );
    },
    [doCreateAccountUsersFetch, accountId]
  );

  // Handle create account users error
  useEffect(() => {
    if (createAccountUsersError === null) return;

    latestOnSubmit.current({
      status: OP_STATUSES.ERROR,
      response: createAccountUsersError,
    });
    dispatch({
      type: ACTIONS.SET_IS_SAVING,
      payload: false,
    });
  }, [createAccountUsersError, dispatch]);

  // Handle create account users success
  useEffect(() => {
    if (createAccountUsers === null) return;

    latestOnSubmit.current({ status: OP_STATUSES.SUCCESS });
    dispatch({
      type: ACTIONS.SET_ARE_USERS_INVITED,
      payload: true,
    });
    dispatch({
      type: ACTIONS.SET_IS_SAVING,
      payload: false,
    });
  }, [createAccountUsers, dispatch]);

  return {
    createAccountUsersRequest,
  };
};

export default useCreateAccountUsers;
